import * as React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./Icon.scss");

const InformationIcon = () => {
    return <span className={style.iconInfo}>i</span>;
};

export default InformationIcon;
